import React, { useState, useEffect } from 'react';
import './Home.css';
import { Button, MenuItem, Container, Icon } from 'semantic-ui-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Virtual } from 'swiper/modules';
import { Link } from 'react-router-dom';
import maintenance from '../pictures/maintenance.png';
import AvailProp from '../pictures/AvailProp.png';
import TenApp from '../pictures/TenApp.png';
import medPic from '../pictures/PAMed.png';
import intPic from '../pictures/int.png';
import jHouse2 from '../pictures/jHouse2.png';
import hillcrest from '../pictures/Hillcrest.png';
import { Helmet } from 'react-helmet-async'

const rentLinks = [
  { to: '/residential-listings', label: 'Residential Properties For Rent' },
  { to: '/short-term-listings', label: <>Short-Term <br /> &amp; <br />Mid-Term Stays</> },
  { to: '/commercial-listings', label: 'Commercial Properties For Rent' },
  { to: '/storage-listings', label: 'Storage / Parking For Rent' },
];

const Home = () => {
  const images = [hillcrest, jHouse2, medPic, intPic];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(false);

  const nextSlide = () => {
    setFade(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      setFade(false);
    }, 500); // Time for fade-out before changing image
  };


  useEffect(() => {
    const interval = setInterval(nextSlide, 5800);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-container">
      <Helmet>
        <title>
          Delta Property Management Group | Harrisburg, PA Property Management
        </title>

        <meta
          name="description"
          content="Delta Property Management Group (Delta PMG) provides residential and commercial property management services in the Harrisburg, PA area. Trusted by landlords and property owners."
        />

        <link
          rel="canonical"
          href="https://www.deltapmg.com/"
        />

        <meta property="og:title" content="Delta Property Management Group | Harrisburg, PA Property Management" />
        <meta property="og:description" content="Professional residential and commercial property management services in the Harrisburg, PA area." />
        <meta property="og:url" content="https://www.deltapmg.com/" />
        <meta property="og:type" content="website" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Delta Property Management Group",
            "url": "https://www.deltapmg.com",
            "telephone": "7176528200",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Harrisburg",
              "addressRegion": "PA",
              "addressCountry": "US"
            }
          })}
        </script>
      </Helmet>
      {/* Hero Section */}
      <section className="hero">
        {images.map((image, index) => (
          <img
            key={index}
            className={`slide ${index === currentIndex ? 'active' : ''} ${fade ? 'fade-out' : 'fade-in'}`}
            src={image}
            alt={`Slide ${index + 1}`}
          />
        ))}

        <Icon
          name="chevron left"
          className="left-arrow"
          onClick={nextSlide}
        />
        <Icon
          name="chevron right"
          className="right-arrow"
          onClick={nextSlide}
        />

        <div className="overlay">
          <Container>
            <div className="ui grid" style={{ minHeight: 270 }}>
              <div className="sixteen wide column">
                <h1 className="font-1">Welcome to Delta Property Management Group, LLC.</h1>
                <h2 className="font-2">Harrisburg, Pennsylvania Property Management</h2>
                <div className="hero-rent-links">
                  {rentLinks.map((link) => (
                    <MenuItem
                      key={link.to}
                      className="logos"
                      as={Link}
                      to={link.to}
                      onClick={(e) => {
                        e.preventDefault();
                        window.location.href = link.to; // hard reload
                      }}
                    >
                      <img src={AvailProp} alt="Available Properties" className="blogo" style={{ cursor: 'pointer' }} />
                      <h4 className="del-white">{link.label}</h4>
                    </MenuItem>
                  ))}
                </div>
              </div>
            </div>
          </Container>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <Container text>
          <h3>Contact Us</h3>
          <Link to="/contact-us">
            <Button primary size="large" className="contact-button">
              Click here to send us a message!
            </Button>
          </Link>
        </Container>
      </section>
    </div>
  );
};

export default Home;
